<template>
  <v-container fluid class="d-flex flex-row">
    <v-navigation-drawer permanent floating>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            Admin
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list dense nav>
        <v-list-item link to="/admin/badge">
          <v-list-item-icon>
            <v-icon>mdi-sticker-emoji</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Badges</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/admin/move-coach-clients">
          <v-list-item-icon>
            <v-icon>mdi-account-switch</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Move Coach Clients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/admin/coach-allocation">
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Coach Allocation</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/admin/assign-accountability-groups">
          <v-list-item-icon>
            <v-icon>mdi-chat</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Assign WhatsApp Groups</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/admin/whats-app-groups-fresh-programs">
          <v-list-item-icon>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>WhatsApp Groups - Fresh Programs</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <router-view class="flex" />
  </v-container>
</template>

<script>
export default {
  name: "Admin",
};
</script>
